import { Colors } from "@jsq/ds/styles";
import { RiskRating } from "~/graphql/supergraphEnums";
import { RiskRatingProps } from "./types";

export const RISK_VALUES: Record<RiskRating, number> = {
  [RiskRating.Low]: 1,
  [RiskRating.Medium]: 2,
  [RiskRating.High]: 3,
  [RiskRating.Halt]: 4,
  [RiskRating.None]: 0,
};

export const RISK_RATING_PROPS: { [key in RiskRating]: RiskRatingProps } = {
  [RiskRating.Low]: {
    hasIcon: true,
    iconType: "gauge-simple-low",
    color: Colors.Success600,
    text: "Low risk",
    sortPosition: 2,
  },
  [RiskRating.Medium]: {
    hasIcon: true,
    iconType: "gauge-simple-med",
    color: Colors.Success600,
    text: "Medium risk",
    sortPosition: 3,
  },
  [RiskRating.High]: {
    hasIcon: true,
    iconType: "gauge-simple-high",
    color: Colors.Danger600,
    text: "High risk",
    sortPosition: 4,
  },
  [RiskRating.Halt]: {
    hasIcon: true,
    iconType: "gauge-simple-max",
    color: Colors.Danger600,
    text: "Halt",
    sortPosition: 5,
  },
  [RiskRating.None]: {
    hasIcon: false,
    iconType: null,
    color: Colors.Neutral999,
    text: "N/A",
    sortPosition: 1,
  },
};

export const ChangeIconColors: Record<string, Colors> = {
  "arrow-down": Colors.Success600,
  "arrow-up": Colors.Danger600,
  dash: Colors.Neutral800,
};
